// extracted by mini-css-extract-plugin
module.exports = {"carsContainer":"CarsGrid_carsContainer__2b1Zi","carsTitle":"CarsGrid_carsTitle__3xTeP"};